/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthService } from 'modules/Authentication/service';
import { AnyAction } from 'redux';
import { getContext, put, takeLatest } from 'redux-saga/effects';
import {
	initAdminUserData,
	login,
	loginFailure,
	loginSuccess,
	logout,
	resetPassword,
	resetPasswordFail,
	resetPasswordRequest,
	resetPasswordRequestFail,
	resetPasswordRequestSuccess,
	resetPasswordSuccess,
	setAdminUserData,
	verifyResetPasswordLink,
	verifyResetPasswordLinkFail,
	verifyResetPasswordLinkSuccess,
} from './slice';

function* loginHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const applicationContext = yield getContext('applicationContext');
		const authService = yield new AuthService(applicationContext);
		const resData = yield authService.login(action.payload);

		const { authToken, refreshToken, admin } = resData;
		applicationContext.setAuthToken(authToken);
		applicationContext.setRefreshToken(refreshToken);
		applicationContext.setAdminUserData(admin);

		if (action.payload.rememberMe) {
			localStorage.setItem('rememberUserEmail', action.payload.email);
		} else {
			localStorage.removeItem('rememberUserEmail');
		}

		yield put(loginSuccess(admin));
	} catch (e) {
		yield put(loginFailure({}));
	}
}

function* initAdminUserDataHandler(): Generator<any, any, any> {
	const applicationContext = yield getContext('applicationContext');

	const userData = applicationContext.adminUserData;
	yield put(setAdminUserData(userData));
}

function* logoutHandler(): Generator<any, any, any> {
	const applicationContext = yield getContext('applicationContext');
	try {
		const authService = yield new AuthService(applicationContext);
		yield authService.logout();
		applicationContext.clearAutheticatedAdminUserData();
	} catch (e) {
		applicationContext.clearAutheticatedAdminUserData();
	}
}

function* resetPasswordRequestHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const applicationContext = yield getContext('applicationContext');
		const authService = yield new AuthService(applicationContext);
		yield authService.resetPasswordRequest(action.payload);
		yield put(resetPasswordRequestSuccess({}));
	} catch (e) {
		yield put(resetPasswordRequestFail({}));
	}
}

function* resetPasswordHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const applicationContext = yield getContext('applicationContext');
		const authService = yield new AuthService(applicationContext);
		yield authService.resetPassword(action.payload);

		yield put(resetPasswordSuccess({}));
	} catch (e) {
		yield put(resetPasswordFail({}));
	}
}

function* verifyResetPasswordLinkHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const applicationContext = yield getContext('applicationContext');
		const authService = yield new AuthService(applicationContext);
		yield authService.verifyResetPasswordLink(action.payload);

		yield put(verifyResetPasswordLinkSuccess({}));
	} catch (e) {
		yield put(verifyResetPasswordLinkFail({}));
	}
}

export function* authSaga() {
	yield takeLatest(login, loginHandler);
	yield takeLatest(logout, logoutHandler);
	yield takeLatest(initAdminUserData, initAdminUserDataHandler);
	yield takeLatest(resetPasswordRequest, resetPasswordRequestHandler);
	yield takeLatest(resetPassword, resetPasswordHandler);
	yield takeLatest(verifyResetPasswordLink, verifyResetPasswordLinkHandler);
}
